import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Exercise } from '../pagination.component';

@Component({
  selector: 'onmat-teacher-settings',
  templateUrl: './teacher-settings.component.html',
  styleUrls: ['./teacher-settings.component.scss'],
})
export class TeacherSettingsComponent {
  @Input() exercise: Exercise;
  @Output() visibilityEmitter: EventEmitter<Exercise> = new EventEmitter<Exercise>();

  clickOnVisibility(exercise: Exercise) {
    this.visibilityEmitter.emit(exercise);
  }
}
